/*

FILE: scroll.js
DESCRIPTION: Functionality for scroll waypoints
AUTHOR(S): R.J. LaCount

*/

const waypoints = require('waypoints/lib/noframework.waypoints.js');
import animateScrollTo from 'animated-scroll-to';

import { elements } from './elements';
import { state } from './state';

const hideContainer = (dir) => {
	const panelContainer = document.querySelectorAll('.image-reveal-container');
	panelContainer.forEach(item => {
		dir === 'up' ? item.classList.remove('show') : item.classList.add('show');
	});
}

const fadeInContainer = (dir) => {
	const panelContainer = document.querySelectorAll('.image-reveal-container');
	panelContainer.forEach(item => {
		dir === 'down' ? item.classList.remove('show') : item.classList.add('show');
	});
}

const fadeInImage = (el, dir) => {
	const panelContainer = document.querySelector('.image-reveal-panels');

	if (panelContainer) {
		const imageReveals = panelContainer.querySelectorAll('.image-reveal');

		imageReveals.forEach((item, index, arr) => {
			item.classList.remove('show');

			if (item.dataset.image === el.dataset.id) {
				const currentItem = dir === 'down' ? arr[index] : arr[index - 1];
				currentItem ? currentItem.classList.add('show') : item.classList.remove('show');

				if (index === 0) {
					const panelContainer = document.querySelectorAll('.image-reveal-container');
					panelContainer.forEach(item => {
						dir === 'down' ? item.classList.add('show') : item.classList.remove('show');
					});
				}
			}
		});
	}
}

const initWaypoints = () => {
	Waypoint.destroyAll();

	new Waypoint({
		element: document.body,
		offset: -100,
		handler: (dir) => {

			if (state.enableTransparentNav) {
				dir === 'down' ? document.body.classList.add('scrolled') : document.body.classList.remove('scrolled');
			}
		}
	});

	// Fade in elements scrolled to
	if (elements.animateIn) {

		elements.animateIn.forEach(el => {
			new Waypoint({
				element: el,
				offset: '80%',
				handler: (dir) => {
					el.classList.add('entered')
					if (el.classList.contains('image-trigger')) fadeInImage(el, dir);
					if (el.classList.contains('footer-trigger')) fadeInContainer(dir);
					if (el.classList.contains('hide-container')) hideContainer(dir);
				}
			});
		});
	}
}

const scrollToEl = (trigger) => {
	const dest = document.querySelector('[data-scroll-dest*="' + trigger.dataset.scrollTo + '"]');
	animateScrollTo(dest);
}

export { initWaypoints, scrollToEl };
